export const GOOGLE_CHARTS_REQUEST = "GOOGLE_CHARTS_REQUEST";
export const GOOGLE_CHARTS_SUCCESS = "GOOGLE_CHARTS_SUCCESS";
export const GOOGLE_CHARTS_FAILURE = "GOOGLE_CHARTS_FAILURE";
